'use strict';

import cookieConsent from './cookieConsent';
import videolink from './videolink';
import slickGallery from './slick-gallery';
import animatedFeatures from './animatedFeatures';
import lazyLoad from './lazyLoad';

document.addEventListener('DOMContentLoaded', () => {
    cookieConsent();
    videolink();
    slickGallery('.gallery');
    animatedFeatures();
    lazyLoad();
});

$(document).ready(function () {

    let scrollOffset = 110;

    //sticky header
    function transformHeader() {
        let scroll = $(window).scrollTop();

        if (scroll > 0) {
            $('.main-header').addClass('sticky');
        } else {
            $('.main-header').removeClass('sticky');
        }
    }
    transformHeader();
    $(window).scroll(function () {
        transformHeader();
    });



    //scroll down on scroll-icon click
    $('.scroll-icon').on( 'click touch', function() {
        let x = $(window).height();
        $('html, body')
            .animate(
                {scrollTop: x},
                500,
                'swing',
                function(){}
            );
    });


    //particles in homepage background
    if ($('#particles-js').length) {
        $.getScript( '/assets/js/particles.min.js', function() {
            particlesJS.load('particles-js', '/assets/js/particles.json');
        });
    }


    //parallax images
    if (ScrollMagic) {
        let controller = new ScrollMagic.Controller();

        //ignore on mobile
        if ($( window ).width() >= 768) {

            let parallaxBuilding = TweenMax
                .to($('#town-parallax > .town-second-layer-bg'), 1, {
                    y: '20%',
                    ease: Linear.easeNone
                })
                .reversed(true);

            new ScrollMagic.Scene({
                triggerElement: this,
                duration: '100%'
            })
                .setTween(parallaxBuilding)
                .addTo(controller);


            let parallaxTitle = TweenMax
                .to($("#town-parallax > .town-second-layer__content"), 1, {
                    y: '-250%',
                    ease: Linear.easeNone
                })
                .reversed(false);

            new ScrollMagic.Scene({
                triggerElement: this,
                duration: '100%'
            })
                .setTween(parallaxTitle)
                .addTo(controller);


            let parallaxTown = TweenMax
                .to($(".town-first-layer-bg"), 1, {
                    y: '-5%',
                    ease: Linear.easeNone
                })
                .reversed(true);

            new ScrollMagic.Scene({
                triggerElement: this,
                duration: '90%'
            })
                .setTween(parallaxTown)
                .addTo(controller);
        }



        $(".parallax").each(function () {
            let parallaxBackground = TweenMax
                .to(jQuery(this).children('.image'), 1, {
                    backgroundPosition: '50% top',
                    ease: Linear.easeNone
                });

            new ScrollMagic.Scene({
                triggerElement: this,
                duration: '200%',
                triggerHook: 'onEnter'
            })
                .setTween(parallaxBackground)
                .addTo(controller);
        });

    }



    //contact form ajax
    let responseContainer = '#contact_form_container';
    let contactForm = $('#contact_form');

    $(contactForm).submit(function(event) {
        event.preventDefault();

        let formData = $(contactForm).serialize();

        $.ajax({
            type: $(contactForm).attr('method') ? $(contactForm).attr('method') : 'POST',
            url: $(contactForm).attr('action'),
            data: formData
        }).done(function() {
            $(responseContainer + ' .success').fadeIn();
            if (fbq) {
                fbq('track', 'Contact');
            }
        }).fail(function() {
            $(responseContainer + ' .error').fadeIn();
        });

    });


    //apartments search form ajax
    let apartmentSearchResultsContainer = $('#apartments-search-result-container');
    let apartmentSearchForm = $('#apartments-search-form');

    function generateTable(apartmentData) {

        const markup = `
            ${apartmentData.map(apartment => {
            return `
                <tr data-href="${apartment.url || ''}" class="apartment-status status-${apartment.status['id'] || '0'}">
                    <td class="no-transform">${apartment.building || ''}</td>
                    <td class="no-transform">${apartment.name || ''}</td>
                    <td>${apartment.status['label'] || ''}</td>
                    <td>${apartment.type || ''}</td>
                    <td>${apartment.area || ''}</td>
                    <td>${apartment.floor || ''}</td>
                    <td>${apartment.rooms || ''}</td>
                    <td>
                        ${apartment.sides.map((side, i) => `
                            ${side}${(apartment.sides.length === i + 1) ? '' : ', '}
                        `).join('')}
                    </td>
                    <td>
                        <span>${apartment.amenities.loggia || '-'}</span><!--
                     --><span>${apartment.amenities.terrace || '-'}</span><!--
                     --><span>${apartment.amenities.garden || '-'}</span>
                    </td>
                    <td class="floor-plan">
                        ${apartment.photo_url ? `
                            <a href="#" target="_blank"><i class="fas fa-search"></i></a>
                            <div class="floor-plan__preview">
                                <img src="${apartment.photo_url || '#'}" alt="${apartment.name || ''}" />
                            </div>
                        ` : ''}
                    </td>
                </tr>
            `;
        })}
        `;

        $('#apartments-search-result-container table tbody').html(markup);
    }

    function generatePagination(pages) {
        let markup = '';

        markup = `
            ${pages.previous_page ? `<div class="page-arrow previous"><a data-page="${pages.previous_page}" href="#page=${pages.previous_page}"><i class="fas fa-chevron-left"></i></a></div>` : ''}
    
            ${pages.previous_page ? `<div class="page page-previous"><a data-page="${pages.previous_page}" href="#page=${pages.previous_page}">${pages.previous_page}</a></div>` : ''}
            <div class="page page-current"><a data-page="${pages.current_page}" href="#page=${pages.current_page}">${pages.current_page}</a></div>
            ${pages.next_page ? `<div class="page page-next"><a data-page="${pages.next_page}" href="#page=${pages.next_page}">${pages.next_page}</a></div>` : ''}
    
            ${pages.total > 2 && pages.current_page === 1 ? `<div class="page page-next"><a data-page="3" href="#page=3">3</a></div>` : ''}
    
            ${pages.next_page ? `<div class="page-arrow next"><a data-page="${pages.next_page}" href="#page=${pages.next_page}"><i class="fas fa-chevron-right"></i></a></div>` : ''}
        `;

        $('#apartments-search-result-container .apartments-pagination').html(markup);
    }

    $(apartmentSearchForm).submit(function(event) {
        event.preventDefault();

        let formData = $(apartmentSearchForm).serialize();

        $.ajax({
            type: $(apartmentSearchForm).attr('method') ? $(apartmentSearchForm).attr('method') : 'GET',
            url: $(apartmentSearchForm).attr('action'),
            data: formData,
            beforeSend: function() {
                $(apartmentSearchResultsContainer).addClass('loading');
            }
        }).done(function(response) {

            $(apartmentSearchResultsContainer).removeClass('loading');

            generateTable(response.data);

            generatePagination(response.pages);

            if ($(window).scrollTop() > $(apartmentSearchResultsContainer).offset().top) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(apartmentSearchResultsContainer).offset().top - scrollOffset
                }, 300);
            }

            if (fbq) {
                fbq('track', 'Search');
            }

        }).fail(function(response) {
            $(apartmentSearchResultsContainer).removeClass('loading');
            alert(response);
        });

    });

    let timer;
    function submitSearchApartmentsForm(timeout, page=1) {
        if (timer) { clearTimeout(timer); }
        timer = setTimeout(function() {
            $('#apartment-search-page').val(page);
            $(apartmentSearchForm).submit();
        }, timeout);

    }
    //submit on input change
    $('#apartments-search-form input, #apartments-search-form select').change(function() {
        submitSearchApartmentsForm(1000);
    });
    //submit on input edit
    $('#apartments-search-form input').on('input', function() {
        submitSearchApartmentsForm(2500);
    });
    //submit on pagination click
    $('.apartments-pagination').on('click', 'a', function(e) {
        e.preventDefault();
        submitSearchApartmentsForm(0, $(this).data('page'));
    });



    //redirection on elements with data-href attribute
    $('body').on('click', '*[data-href]', function(){
        window.location = $(this).data('href');
        return false;
    });

    //scroll on elements with href hash
    $('a[href*=\\#]').on('click', function(e){

        if (!$(this).data('page')) {

            let href = $(this).attr('href');
            var hash = href.substr(href.indexOf('#')+1);

            if (hash && $('#'+hash).length) {
                let position = $('#'+hash).position();

                if (position && position.top) {

                    e.preventDefault();

                    $('html, body')
                        .animate(
                            {scrollTop: position.top - scrollOffset},
                            500,
                            'swing',
                            function () {
                            }
                        );

                }
            }

        }
    });


    //scroll on elements with data-scroll attribute
    $('*[data-scroll]').on('click', function(e){
        e.preventDefault();

        let element = $(this).data('scroll');

        if ($('#' + element).length) {
            let position = $('#' + element).position();

            if (position && position.top) {

                $('html, body')
                    .animate(
                        {scrollTop: position.top - scrollOffset},
                        500,
                        'swing',
                        function () {
                        }
                    );

            }
        }
    });



    //floorChoser hover & click
    $('.floor-chooser-pp svg > *').on('mouseenter', function(){
        let id = $(this).data('rel');
        $('.tooltip.'+id).addClass('visible');
    }).on('mouseleave', function(){
        let id = $(this).data('rel');
        $('.tooltip.'+id).removeClass('visible');
    }).on('click', function(){
        let building = $(this).data('building');
        let floor = $(this).data('floor');

        if (building && floor) {
            $('#search-building').val(building);
            $('#search-floor-from').val(floor);
            $('#search-floor-to').val(floor);
        }

        if ($(apartmentSearchForm).length) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(apartmentSearchForm).offset().top - scrollOffset
            }, 300);
        }

        if ($(apartmentSearchForm).length) {
            $(apartmentSearchForm).trigger('submit');
        }

    });

    //hide menu on click outside
    const outsideClickListener = (event) => {
        let selector = '.main-header.header';
        let target = $(event.target);

        if (!target.closest(selector).length && $(selector).hasClass('opened')) {
            $(selector).removeClass('opened');
            document.removeEventListener('click', outsideClickListener);
        }
    };

    //open menu on mobile
    if ($( window ).width() < 768) {
        let headerElement = $('.main-header.header');
        headerElement.on('click', '.header__menu', function(){

            if (headerElement.hasClass('opened')) {
                document.removeEventListener('click', outsideClickListener);
            } else {
                document.addEventListener('click', outsideClickListener);
            }

            headerElement.toggleClass('opened');

        });
    }


    //additional fb pixel events
    $('.tracked-email').on('click', function(){
        if (fbq) {
            fbq('track', 'Lead');
        }
    });

});
